import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Card, Form, Input, Button, Typography, message } from 'antd';
import { PhoneOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { affiliateService } from '../../common/services/api';
import './AffiliePage.css';

const { Title, Paragraph, Text } = Typography;

const AffiliateLoginPage = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const response = await affiliateService.login(values.phone, values.password);
            if (response.success) {
                // Stocker les infos de l'affilié
                localStorage.setItem('affiliateToken', response.data.accessToken);
                localStorage.setItem('affiliateUser', JSON.stringify(response.data));
                message.success('Connexion réussie !');
                navigate('/affilies/dashboard');
            } else {
                message.error(response.message || 'Erreur de connexion');
            }
        } catch (error) {
            message.error(error.message || 'Identifiants incorrects');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="affiliate-login-page">
            <div className="login-container">
                <Card className="login-card">
                    <div className="login-header">
                        <Title level={2}>Espace Affilié</Title>
                        <Paragraph>
                            Connectez-vous pour accéder à votre tableau de bord et suivre vos parrainages.
                        </Paragraph>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={false}
                    >
                        <Form.Item
                            name="phone"
                            label="Téléphone"
                            rules={[{ required: true, message: 'Veuillez entrer votre numéro' }]}
                        >
                            <Input
                                prefix={<PhoneOutlined />}
                                placeholder="Votre numéro de téléphone"
                                size="large"
                                onChange={(e) => {
                                    // Supprimer les espaces automatiquement
                                    const cleanValue = e.target.value.replace(/\s/g, '');
                                    form.setFieldValue('phone', cleanValue);
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            label="Mot de passe"
                            rules={[{ required: true, message: 'Veuillez entrer votre mot de passe' }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Votre mot de passe"
                                size="large"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                                block
                                loading={loading}
                                icon={<LoginOutlined />}
                            >
                                Se connecter
                            </Button>
                        </Form.Item>
                    </Form>

                    <div className="login-footer">
                        <Text type="secondary">
                            Pas encore affilié ?{' '}
                            <Link to="/affilies/inscription">Inscrivez-vous</Link>
                        </Text>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default AffiliateLoginPage;
